import React from "react"
import { AppCardTitle, AppDataTable, AppResultsSkeleton } from "@components"
import { alertsSection } from "Pages/ReportsAlerts/Alerts/@signals"
import { ALERTS_ICONS } from "Pages/ReportsAlerts/Alerts/@components/Tabs"
import AlertsTableCustomToolbar from "Pages/ReportsAlerts/Alerts/Conditions/@components/Table/Toolbar"


export default function AlertsBaseTable(
	{
		title,
		data,
		columns,
		isLoading,
		filterConditions,
		legend = [],
		isNoAvailability = false,
		// the list's create button (Conditions), after the table's own actions
		createButton = null,
	}) {
	return <>
		{isLoading && <AppResultsSkeleton rows={10} columns={5}/>}
		{!isLoading && <AppDataTable
			toolbarProps={{ actions: false }}
			// the title stays on one line; the legend wraps to the next one when the toolbar is full
			title={<AppCardTitle icon={ALERTS_ICONS[alertsSection.value]} title={title} sx={{ '& .MuiTypography-root': { whiteSpace: 'nowrap' } }}/>}
			data={Array.isArray(data) ? data : []}
			columns={columns}
			options={{
				exportExcel: false,
				search: true,
				viewColumns: true,
				customToolbar: () => <>
					<AlertsTableCustomToolbar
						legendElements={legend}
						filterConditions={filterConditions}
						isNoAvailability={isNoAvailability}
					/>
					{createButton}
				</>,
			}}
		/>}
	</>
}


